import React from 'react';
import classNames from 'classnames';

import {parseGetParamsForUrl, parseUrlPath, toGetQuery} from 'utils/urls';
import ExifOrientationImg from 'components/ExifOrientationImg';

import './styles.css';

interface AvatarProps {
  className?: string;
  initials: string;
  url?: string;
  onClick?: () => {};
  white?: boolean;
  width?: number;
}

function getScaledImageUrl(url: string, width?: number) {
  if (width) {
    const paramsString = toGetQuery({...parseGetParamsForUrl(url), w: width});

    const urlPath = parseUrlPath(url);

    return `${urlPath}?${paramsString}`;
  }
  return url;
}

const Avatar = ({
  className,
  url,
  initials,
  onClick,
  white,
  width = 256 // This is the widest that we ever show as avatar
}: AvatarProps) => (
  <React.Fragment>
    {url && (
      <ExifOrientationImg
        className={classNames(className, 'Avatar')}
        src={getScaledImageUrl(url, width)}
        onClick={onClick}
      />
    )}
    {!url && (
      <div
        className={classNames(className, 'NoAvatar', {white})}
        onClick={onClick}>
        <p className={classNames('initials', {dark: white})}>{initials}</p>
      </div>
    )}
  </React.Fragment>
);

export default Avatar;
